import { NotificationStatuses } from "@jsainsburyplc/id-ui-common";

import {
  incorrectCodeErrorMessage,
  maxAttemptsErrorMessage,
  defaultErrorMessage,
  expiredCodeErrorMessage,
} from "constants/mfaAndOtp";
import { OTP_EXPIRED, OTP_INVALID, OTP_MAX_ATTEMPTS } from "constants/codes";

export const getErrorMessage = (errorCode) => {
  const errorMessage = { type: NotificationStatuses.ERROR_TYPE };
  switch (errorCode) {
    case OTP_INVALID:
      return {
        ...errorMessage,
        text: incorrectCodeErrorMessage,
      };
    case OTP_EXPIRED:
      return {
        ...errorMessage,
        text: expiredCodeErrorMessage,
      };
    case OTP_MAX_ATTEMPTS:
      return {
        ...errorMessage,
        text: maxAttemptsErrorMessage,
      };
    default:
      return {
        ...errorMessage,
        text: defaultErrorMessage,
      };
  }
};
